// How large a star glyph is drawn (docs/02-Game-Design/Sky & Viewport.md),
// shared by the board, the share image and the Worker's share page.

/** A glyph is drawn at this share of its sky-unit size wherever that leaves it at least MIN_GLYPH_PX. */
export const GLYPH_DRAW_FRACTION = 0.72;
/** What a landscape phone (390 px tall) already draws; smaller screens keep the full glyph. */
export const MIN_GLYPH_PX = 39;

/**
 * How much the star glyphs are drawn below their sky-unit size. They still
 * scale with the sky, only smaller: 28% smaller on tablets and desktops, while
 * phones, where a smaller glyph would no longer hold its letter, keep the full one.
 */
export function glyphScale(scale: number, glyphUnits: number): number {
  return Math.min(1, Math.max(GLYPH_DRAW_FRACTION, MIN_GLYPH_PX / (glyphUnits * scale)));
}
